import React, { FC } from "react";
import { Wrapper } from "../../../common/constants/core.style";
import {
    HeroContent,
    HeroMedia,
    HeroPanel,
    HeroTagline,
    Intro,
    MainGrid,
    MainSection,
    StepList,
    StepNumber,
    TrustGrid,
    TrustItem,
    TrustStrip,
} from "./style";
import ApplicationForm from "../components/applicationForm";
import { Images } from "../../../common/constants/images";

const NursingJobs: FC = () => {
    return (
        <>
            <HeroMedia>
                <img
                    src={Images.NursingBannerWeb}
                    alt="Professional nurse ready for a healthcare career in New Zealand"
                    className="desktop-image"
                    width="1921"
                    height="500"
                />
                <img
                    src={Images.NursingBannerMob}
                    alt="Professional nurse ready for a healthcare career in New Zealand"
                    className="mobile-image"
                    width="480"
                    height="480"
                />
            </HeroMedia>
            <HeroPanel>
                <Wrapper>
                    <HeroContent>
                        <HeroTagline>Nursing Careers in New Zealand</HeroTagline>
                        <h1>Your Partner in Nursing Careers</h1>
                        <p>Explore exciting nursing opportunities in New Zealand and take the next step in your healthcare career.</p>
                        <a href="#application-form">
                            Start Your Application
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                            </svg>
                        </a>
                    </HeroContent>
                </Wrapper>
            </HeroPanel>

            <TrustStrip>
                <Wrapper>
                    <TrustGrid>
                        <TrustItem>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.7" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            </svg>
                            <span>NZ Nursing Council Guidance</span>
                        </TrustItem>
                        <TrustItem>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.7" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.5 19.5a7.5 7.5 0 0 1 15 0v.75H4.5v-.75Z" />
                            </svg>
                            <span>Dedicated Recruitment Team</span>
                        </TrustItem>
                        <TrustItem>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.7" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a48.6 48.6 0 0 1-8.135-.687c-.524-.087-.913-.518-.913-1.05V8.706a1.05 1.05 0 0 1 .913-1.05A48.6 48.6 0 0 1 12 6.97c2.755 0 5.455.232 8.135.687.524.087.913.518.913 1.05v10.557a1.05 1.05 0 0 1-.913 1.05A48.6 48.6 0 0 1 12 21Z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.97V5.25A2.25 2.25 0 0 1 10.5 3h3a2.25 2.25 0 0 1 2.25 2.25v1.72" />
                            </svg>
                            <span>Career &amp; Visa Support</span>
                        </TrustItem>
                        <TrustItem>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.7" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.96 11.96 0 0 1 3.6 6.16a11.96 11.96 0 0 0-.6 3.78c0 5.6 3.82 10.31 9 11.64 5.18-1.33 9-6.04 9-11.64 0-1.31-.21-2.58-.6-3.78a11.96 11.96 0 0 1-8.4-3.448Z" />
                            </svg>
                            <span>Confidential &amp; Trusted</span>
                        </TrustItem>
                    </TrustGrid>
                </Wrapper>
            </TrustStrip>

            <MainSection>
                <Wrapper>
                    <MainGrid>
                        <Intro>
                            <h2>Start Your New Zealand <span>Nursing Journey</span></h2>
                            <p>Thank you for your interest in exploring nursing opportunities in New Zealand.</p>
                            <p>Please complete the form so our team can better understand your qualifications, experience, and career goals. The information you provide will help us assess your eligibility and guide you through the next steps of your New Zealand nursing journey.</p>
                            <StepList>
                                <li>
                                    <StepNumber>1</StepNumber>
                                    <div>
                                        <strong>Share your details</strong>
                                        <span>Tell us about your qualifications, experience and specialty.</span>
                                    </div>
                                </li>
                                <li>
                                    <StepNumber>2</StepNumber>
                                    <div>
                                        <strong>Eligibility assessment</strong>
                                        <span>Our team reviews your profile against NZ registration pathways.</span>
                                    </div>
                                </li>
                                <li>
                                    <StepNumber>3</StepNumber>
                                    <div>
                                        <strong>Personalised guidance</strong>
                                        <span>We contact you with the right next steps for your career.</span>
                                    </div>
                                </li>
                            </StepList>
                        </Intro>
                        <ApplicationForm />
                    </MainGrid>
                </Wrapper>
            </MainSection>
        </>
    );
};

export default NursingJobs;
